import { WorkflowPreset } from '../types';

/**
 * Default preset: loads the original OHIF viewer with worklist and all
 * settings. No CurveBeam overrides are applied — studyBrowser filter bar
 * is visible, return-to-worklist button is enabled, all tools shown.
 */
export const defaultPreset: WorkflowPreset = {
  id: 'default',
  label: 'OHIF Default',
  header: {
    showPatientInfo: true,
    showReturnButton: true,
  },
  customizations: {
    'studyBrowser.hideFilterBar': false,
  },
  dataFilters: {
    allowMrnWidening: true,
  },
};
